import React from 'react';
import './RegistrationHeader.scss';
// import { selectableLanguages } from "../../../lang/config";
// import DropDown from "../../../components/DropDown/DropDown";
import cpLogo from './cp_logo.png';

// Example: languageSelection = [{id: 'Eng', displayName: 'English'}, {id: 'FR', displayName: 'French'}];
const RegistrationHeader = ({
  languageSelection,
  selectedLanguage,
  onChangeLanguage,
  navigateOnClickLogoImage = '',
}) => {
  const onClickLogoImage = (event) => {
    navigateOnClickLogoImage
      ? navigateOnClickLogoImage()
      : event.preventDefault();
  };
  /*
    const onChange = (data) => {
        onChangeLanguage(data);
    };

    if (languageSelection && !onChangeLanguage) {
        console.error(`onChangeLanguage function was not supplied
            please supply one, or remove languageSelection array`);
    }
    let markup = (
        <div className="btn-group padTop">
        </div>
    );
    if (languageSelection && languageSelection.length > 0 && onChangeLanguage) {
        const currentLanguage = selectedLanguage || languageSelection[0];
        markup = (
            <DropDown
                onChange={onChange}
                defaultSelected={currentLanguage}
                values={selectableLanguages}/>
        );
    }
    */
  return (
    <div className='registration--headerBar'>
      <div className='row title-padding-top'>
        <span
          className='registration--headerBar-clickable'
          onClick={onClickLogoImage}
        >
          <img
            className='creditPlace-logo'
            src={cpLogo}
            alt='CREDITPLACE LOGO'
          />
        </span>
      </div>
      {/* {markup} */}
    </div>
  );
};

export default RegistrationHeader;
